import type { ReactNode } from "react";
import { Icon } from "../icons/Icon";
import { cx } from "../utils/format";
import type { Priority } from "../types";

/** A small state word. Tones: the priorities, "plain" (no dot), and (the summary cards round, 2026-11-01) "on" (the success tint) and
 *  "off" (muted) for a switch's state in a facts card; never the AI hue. */
export function Pill({ tone = "plain", children }: { tone?: Priority | "plain" | "on" | "off"; children: ReactNode }) {
  return <span className={cx("ob-pill", `ob-pill--${tone}`)}>{children}</span>;
}

/** The only component allowed to use the reserved AI hue. */
export function AiTag({ children, generating, title }: { children: ReactNode; generating?: boolean; /** a hint on hover (M9: "The model as reported by the AI") */ title?: string }) {
  return <span className={cx("ob-ai-tag", generating && "ob-ai-tag--generating")} title={title}><Icon name="sparkles" size="xs" />{children}</span>;
}

/** The AI's mark alone (the ticket style round, 2026-10-26: the summary strip): the sparkle without words, the words its spoken name and tooltip. */
export function AiMark({ label }: { /** what the mark says, e.g. "AI summary" */ label: string }) {
  return <span className="ob-ai-tag ob-ai-tag--icon" role="img" aria-label={label} data-tip={label} tabIndex={0}><Icon name="sparkles" size="xs" /></span>;
}

/** Confidence as plain text; the same treatment as the list rows, no bar, no pill. */
export function ConfidenceMeter({ value }: { value: number }) {
  const tone = value >= 0.9 ? "high" : value < 0.6 ? "low" : "mid";
  return <span className={cx("ob-confidence", `ob-confidence--${tone}`)}>{Math.round(value * 100)} % confidence</span>;
}
